import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { trackEvent } from '../../../../../helpers/analytics';
import { createTableColumn, useCreateCustomFieldMutation } from '../../../../../services/customFieldsV2';
import { CustomFieldForm } from './customFieldForm';

export const CreateCustomField = ({ selectedColumns, setSelectedColumns, onBack, page }) => {
  const [createCustomField, { isLoading }] = useCreateCustomFieldMutation();
  const { listId } = useParams();

  const handleSubmit = ({ name, type, scope, options }) => {
    createCustomField({
      name,
      type: type.value,
      ...(type.value === 'single_select'
        ? { params: { options: options.map((o) => ({ label: o.label?.trim() })).filter((o) => o.label) } }
        : {}),
      ...(scope.value === 'list-specific' && listId ? { sharedListId: listId } : undefined),
    })
      .unwrap()
      .then((response) => {
        const column = createTableColumn(response);

        setSelectedColumns([...selectedColumns, column], 'create_custom_field', column);
        trackEvent('contacts:custom_field:created', {
          listId,
          type: type.value,
          customFieldId: response.id,
          global: scope.value === 'global',
        });

        onBack();
      });
  };

  return (
    <Box
      sx={{
        p: '16px',
        width: '320px',
        boxShadow: '0px 2px 32px 0px #1B24320F, 0px 1px 4px 0px #1B24320F',
        position: 'absolute',
        left: ['-100px', '-100px', '0'],
        top: '30px',
        zIndex: 11000,
        backgroundColor: 'white',
      }}
    >
      <Flex alignItems="center" sx={{ gap: '8px' }}>
        <Box
          as={ChevronLeft}
          width="16px"
          height="16px"
          aria-hidden="true"
          onClick={onBack}
          sx={{ cursor: 'pointer', color: 'neutral.500', '&:hover': { color: 'neutral.700' } }}
        />
        <Text fontSize="14px" fontWeight="medium">
          Create custom field
        </Text>
      </Flex>
      <CustomFieldForm isLoading={isLoading} onSubmit={handleSubmit} onCancel={onBack} page={page} />
    </Box>
  );
};

CreateCustomField.propTypes = {
  selectedColumns: PropTypes.array.isRequired,
  setSelectedColumns: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  page: PropTypes.string,
};

CreateCustomField.defaultProps = {
  page: null,
};
